<template>
	<div
		class="component c-social padding-y-24 bp-768:padding-y-48"
		:class="{ dark: section.dark_mode }"
		v-bind:style="{
			'background-image': 'url(' + section.backgroundImage + ') ',
		}"
	>
		<div class="row padding-x-12 ">
			<common-header
				:headline="section.headline"
				:sponsor="section.sponsor"
			/>
		</div>
		<div class=" row padding-t-12">
			<div class="d-flex flex-wrap-wrap w-100 flex-grow-1 padding-x-6">
				<div
					v-for="(item, index) in tweets"
					v-bind:style="{ order: index * 2 }"
					:key="item.id"
					class="d-flex padding-6 width-100 bp-768:width-50 bp-1024:width-33 bp-1280:width-33 "
				>
					<div
						class="c-contentstream__item c-contentstream__item--twitter width-100 flex-direction-column align-items-end"
						:style="
							`background-image: url(${item.media}); background-size: 100% auto; background-position: top center; background-repeat: no-repeat`
						"
						style="display: flex; min-height: 500px;"
					>
						<div
							class="c-contentstream__item-inner c-contentstream__item-inner--twitter d-flex flex-direction-column align-items-end height-auto"
							style="background: var(--main-color); min-height: 300px;"
							:style="item.media ? 'bottom: 0; top: auto;' : ''"
						>
							<div
								class="c-contentstream__user c-contentstream__user--twitter d-flex align-items-center padding-24 line-height-125 flex-shrink-0"
							>
								<span
									class="d-inline-block c-contentstream__user-icon sf-twitter margin-r-12 font-size-24"
								></span>
								<a
									:href="
										'http://twitter.com/' +
											item.user.screen_name
									"
									class="c-contentstream__user-name c-contentstream__user-name--twitter font-weight-bold font-size-14"
									>@{{ item.user.screen_name }}</a
								>
							</div>
							<div
								class="c-contentstream__body padding-x-24 font-weight-300 line-height-175 margin-b-auto padding-b-24"
								v-html="item.text"
							></div>
							<a
								v-if="item.media"
								:href="
									'https://twitter.com/' +
										item.user.screen_name +
										'/status/' +
										item.id
								"
								target="_blank"
								class="c-contentstream__button margin-24 flex-shrink-0  padding-x-24 padding-y-12 d-inline-block font-size-12 line-height-125 font-weight-700"
								>view media</a
							>
							<div
								class="c-contentstream__footer padding-y-16 width-100 flex-shrink-0"
								style="background: var(--main-color);"
							>
								<ul
									class="c-contentstream__actions reset-list w-100 d-flex align-items-center justify-content-center font-size-24 line-height-1"
								>
									<li
										class="c-contentstream__actions-item margin-x-12"
									>
										<a
											class="c-contentstream__actions-link"
											:href="
												'https://twitter.com/intent/favorite?tweet_id=' +
													item.id
											"
											aria-label="Favorite this tweet"
											target="_blank"
										>
											<span
												aria-hidden="true"
												class="sf-twitter-like sidearm-icon"
											></span>
										</a>
									</li>
									<li
										class="c-contentstream__actions-item margin-x-12"
									>
										<a
											class="c-contentstream__actions-link"
											:href="
												'https://twitter.com/intent/retweet?tweet_id=' +
													item.id
											"
											aria-label="Retweet this tweet"
											target="_blank"
										>
											<span
												aria-hidden="true"
												class="sf-twitter-retweet sidearm-icon"
											></span>
										</a>
									</li>
									<li
										class="c-contentstream__actions-item margin-x-12"
									>
										<a
											class="c-contentstream__actions-link"
											:href="
												'https://twitter.com/intent/tweet?in_reply_to=' +
													item.id
											"
											aria-label="Reply to this tweet"
											target="_blank"
										>
											<span
												aria-hidden="true"
												class="sf-twitter-reply sidearm-icon"
											></span>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div
					v-for="(item, index) in instagrams"
					:key="item.id"
					class="d-flex padding-6 width-100 bp-768:width-50 bp-1024:width-33 bp-1280:width-33 "
					v-bind:style="{ order: index * 2 }"
				>
					<div
						class="c-contentstream__item c-contentstream__item--instagram width-100"
					>
						<div
							class="c-contentstream__item-inner c-contentstream__item-inner--instagram"
						>
							<div
								class="c-contentstream__media-container c-contentstream__media-container--instagram"
							>
								<a
									:href="item.link"
									target="_blank"
									class="c-contentstream__media-link"
								>
									<img
										class="c-contentstream__media c-contentstream__media--instagram"
										:src="
											item.images.standard_resolution.url
										"
										:alt="
											item.caption
												? item.caption.text
												: 'No Instagram caption available'
										"
									/>
								</a>
							</div>
							<div
								class="c-contentstream__user c-contentstream__user--instagram d-flex align-items-center padding-24 line-height-125"
							>
								<span
									class="d-inline-block c-contentstream__user-icon sf-instagram margin-r-12 font-size-24"
								></span>
								<a
									:href="
										'http://instagram.com/' +
											item.user.username
									"
									class="c-contentstream__user-name c-contentstream__user-name--instagram font-weight-bold font-size-14"
									>{{ item.user.username }}</a
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<button
			class="s-common__button font-size-14 line-height-125 font-weight-700 margin-t-12"
			@click="load_more"
		>
			Show More
		</button>
	</div>
</template>

<script>
import SectionBase from './SectionBase';
import Client from '@/client';
import CommonHeader from '@/components/common/CommonHeader.vue';
import { should_use_v2_api } from '@/helpers';
export default {
	extends: SectionBase,
	name: 'SectionSocial',
	components: { CommonHeader },
	data: () => ({
		tweets: [],
		instagrams: [],
		skip: 0,
		take: 6,
		is_loading_more: false,
		show_dfp: false,
	}),
	computed: {
		twitter() {
			return this.section.twitter || this.$root.sport.sport_twitter_name;
		},
		instagram() {
			return (
				this.section.instagram || this.$root.sport.sport_instagram_name
			);
		},
		combined_data() {
			return this.tweets.concat(this.instagrams);
		},
		twitter_link() {
			if (!this.twitter) {
				return '';
			}
			let twitter_search_terms = this.twitter.split(/,| /);

			for (let i = 0; i < twitter_search_terms.length; i++) {
				let search_term = twitter_search_terms[i];
				if (search_term.substring(0, 1) === '@') {
					return this.trim_start('@', search_term);
				} else if (search_term.substring(0, 1) !== '#') {
					return search_term;
				}
			}

			return '';
		},
		instagram_link() {
			if (!this.instagram) {
				return '';
			}
			let instagram_search_terms = this.instagram.split(/,| /);

			for (let i = 0; i < instagram_search_terms.length; i++) {
				let search_term = instagram_search_terms[i];
				if (search_term.substring(0, 1) === '@') {
					return this.trim_start('@', search_term);
				} else if (search_term.substring(0, 1) !== '#') {
					return search_term;
				}
			}

			return '';
		},
	},
	methods: {
		get_tweets() {
			// Probably deprecated (changes to X API), cannot find a working example
			if (this.section.includeTwitter) {
				if (should_use_v2_api()) {
					this.fetch_tweets_from_v2_api();
				} else {
					this.fetch_tweets_from_legacy_api();
				}
			}
		},
		fetch_tweets_from_legacy_api() {
			Client.get('/services/signingday.ashx', {
				params: {
					type: 'get-tweets',
					twitter: this.twitter,
					skip: this.skip,
					take: this.take,
					id: 16,
				},
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Content-type': 'application/json',
				},
			}).then(response => {
				if (response.data && response.data.length) {
					this.tweets = this.tweets.concat(response.data);
				}
			});
		},
		fetch_tweets_from_v2_api() {
			// Not going to reattempt to recreate this because existing signing days with Twitter data seem to always return [] now
		},
		get_instagrams() {
			if (this.section.includeInstagram) {
				if (should_use_v2_api()) {
					this.fetch_instagram_posts_from_v2_api();
				} else {
					this.fetch_instagram_posts_from_legacy_api();
				}
			}
		},
		fetch_instagram_posts_from_legacy_api() {
			Client.get('/services/signingday.ashx', {
				params: {
					type: 'get-instagrams',
					instagram: this.instagram,
					skip: this.skip,
					take: this.take,
					id: this.$root.signing_day.id,
				},
				headers: {
					'Access-Control-Allow-Origin': '*',
					'Content-type': 'application/json',
				},
			}).then(response => {
				if (response && response.data && response.data.length) {
					this.instagrams = this.instagrams.concat(response.data);
				}
			});
		},
		fetch_instagram_posts_from_v2_api() {
			Client.get('/api/v2/Instagram/by-account', {
				params: {
					accountNames: this.instagram,
					$pageIndex: Math.ceil(this.skip / this.take) + 1,
					$pageSize: this.take,
				},
			}).then(response => {
				if (
					response &&
					response.data &&
					response.data.items &&
					response.data.items.length
				) {
					this.instagrams = this.instagrams.concat(
						this.map_v2_instagram_response(response.data.items),
					);
				}
			});
		},
		map_v2_instagram_response(posts) {
			return posts.map(x => ({
				link: x.link,
				id: x.id,
				tags: x.tags,
				comments: x.comments,
				likes: x.likes,
				images: {
					thumbnail: x.images.thumbnail,
					low_resolution: x.images.lowResolution,
					standard_resolution: x.images.standardResolution,
				},
				caption: {
					id: x.caption.id,
					text: x.caption.text,
					created_time: x.caption.createdTime,
					from: x.caption.from,
				},
				video: x.video,
				user: {
					id: x.user.id,
					full_name: x.user.fullName,
					profile_picture: x.user.profilePicture,
					username: x.user.username,
				},
				date: x.date,
				created_time: x.createdTime,
			}));
		},
		trim_start(character, string) {
			var startIndex = 0;

			while (string[startIndex] === character) {
				startIndex++;
			}

			return string.substr(startIndex);
		},
		load_more() {
			this.is_loading_more = true;
			this.skip += this.take;

			let twitter_promise = this.get_tweets();
			let instagram_promise = this.get_instagrams();
			Promise.all([twitter_promise, instagram_promise]).then(() => {
				this.is_loading_more = false;
			});
		},
	},
	mounted() {
		this.get_tweets();
		this.get_instagrams();
	},
};
</script>

<style scoped lang="scss">
.c-contentstream {
	&__item {
		background: $main-color;
		border: solid 1px $main-border-color;
		border-radius: 10px;
		overflow: hidden;
		position: relative;
		width: 100%;
		padding-bottom: 100%;
		&--instagram {
			background: black;
			padding-bottom: 0;
			position: relative;
			&:hover {
				.c-contentstream__media-container--instagram {
					&::before {
						opacity: 0.5;
					}
				}
			}
		}
	}
	&__item-inner {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		&--instagram {
			padding-bottom: 0;
			width: auto;
			height: auto;
			position: relative;
		}
	}

	&__body {
		overflow: auto;
		color: $main-font-color;
	}

	&__button {
		text-decoration: none;
		background: $color-primary;
		color: $text-on-primary;
		text-transform: uppercase;
		transition: 0.3s;
		cursor: pointer;
		&:hover,
		&:focus {
			background: $color-secondary;
			color: $text-on-secondary;
		}
	}

	&__footer {
		border-top: solid 1px $main-border-color;
	}

	&__media-container--instagram {
		width: 100%;
		padding-bottom: 100%;
		position: relative;
		overflow: hidden;
		background: black;
		&::before {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 75%;
			content: '';
			background: linear-gradient(
				180deg,
				rgba(0, 0, 0, 0) 0%,
				#000000 100%
			);
			z-index: 2;
			pointer-events: none;
			transition: 0.3s;
		}
	}
	&__media-link {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	&__media--instagram {
		position: absolute;
		top: 50%;
		left: 50%;
		width: auto;
		height: auto;
		max-width: 100%;
		max-height: 100%;
		z-index: 1;
		transform: translate(-50%, -50%);
	}

	&__user {
		color: $main-font-color;
	}

	&__user--instagram {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 3;
		color: white;
		pointer-events: none;
	}
	&__user-name {
		text-decoration: none;
		color: $main-font-color;
		pointer-events: all;
		&:hover,
		&:focus {
			text-decoration: underline;
		}

		&--instagram {
			color: white;
		}
	}

	@media screen and (max-width: 767px) {
		&__item {
			padding-bottom: 0;
		}
		&__item-inner {
			height: auto;
			// position: relative;
		}
		&__media-container--instagram {
			padding-bottom: 0;
		}
		&__media-link {
			position: relative;
		}
		&__media--instagram {
			position: relative;
			top: 0;
			left: 0;
			transform: none;
		}
	}
}
</style>
